@if (loading) {
  <div class="p-5 text-center">
    <fa-icon icon="spinner" animation="spin" size="3x"></fa-icon>
  </div>
}

@if (!loading && !accesses?.length) {
  <div class="alert alert-success">
    <p class="mb-0">{{ "Template.DataApprovalsComponent.text_noRequests" | translate }}</p>
  </div>
}

@if (!loading && (accesses | statusFilter : 'REQUESTED')?.length) {
  <div class="mb-4">
    <h5 class="mb-0">{{ "Template.DataApprovalsComponent.subHeader_pendingRequests" | translate }}</h5>
    @if (!loading && accesses?.length) {
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_company" | translate }}</th>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_person" | translate }}</th>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_requested" | translate }}</th>
            <th scope="col">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (access of accesses | statusFilter : 'REQUESTED'; track access) {
            <tr>
              <td scope="row" class="align-middle">
                <strong class="d-block">{{ "Template.DataApprovalsComponent.text_customerNo" | translate : { customerNo: access.customer! | identification : "CUSTOMER_NO" } }}</strong>
                <small class="d-block">{{ "Template.DataApprovalsComponent.text_gln" | translate : { gln: access.customer! | identification : "GLN" } }}</small>
                <span class="d-block">{{access.customer?.attributes?.["NAME"]}}</span>
                @if (access.partyContact) {
                  <small class="d-block">
                    @if (access.partyContact.street) {
                      <span class="d-block">{{ access.partyContact.street }}</span>
                    }
                    @if (access.partyContact.zip && access.partyContact.city) {
                      <span class="d-block"> {{ access.partyContact.zip }} {{ access.partyContact.city }} </span>
                    }
                    @if (access.partyContact.country) {
                      <span class="d-block">{{ access.partyContact.country }}</span>
                    }
                  </small>
                }
              </td>
              <td class="align-middle">
                <span class="d-block">
                  {{ access.personFirstname! }}
                  {{ access.personLastname! }}
                </span>
                <a [href]="'mailto:' + access.personEmail" class="d-block">{{ access.personEmail }}</a>
              </td>
              <td class="align-middle text-nowrap">{{ "Template.DataApprovalsComponent.text_dateTime" | translate : { dateTime: access.requestDate | date : "dd.MM.yyyy, HH:mm" } }}</td>
              <td class="text-right align-middle">
                <button (click)="setAccess(access, 'APPROVED')" class="btn btn-success btn-sm d-block w-100" [disabled]="access.loading">
                  @if (!access.loading) {
                    <fa-icon icon="check"></fa-icon>
                  }
                  @if (access.loading) {
                    <fa-icon icon="spinner" animation="spin"></fa-icon>
                  }
                  {{ "Template.DataApprovalsComponent.btn_accept" | translate }}
                </button>
                <button (click)="setAccess(access, 'DENIED')" class="btn btn-danger btn-sm d-block w-100 mt-1" [disabled]="access.loading">
                  @if (!access.loading) {
                    <fa-icon icon="times"></fa-icon>
                  }
                  @if (access.loading) {
                    <fa-icon icon="spinner" animation="spin"></fa-icon>
                  }
                  {{ "Template.DataApprovalsComponent.btn_deny" | translate }}
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
}

@if (!loading && (accesses | statusFilter : 'APPROVED')?.length) {
  <div class="mb-4">
    <h5 class="mb-0">{{ "Template.DataApprovalsComponent.subHeader_approvedRequests" | translate }}</h5>
    @if (!loading && accesses?.length) {
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_company" | translate }}</th>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_person" | translate }}</th>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_requested" | translate }}</th>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_approved" | translate }}</th>
            <th scope="col">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (access of accesses | statusFilter : 'APPROVED'; track access) {
            <tr>
              <td scope="row" class="align-middle">
                <strong class="d-block">{{ "Template.DataApprovalsComponent.text_customerNo" | translate : { customerNo: access.customer! | identification : "CUSTOMER_NO" } }}</strong>
                <small class="d-block">{{ "Template.DataApprovalsComponent.text_gln" | translate : { gln: access.customer! | identification : "GLN" } }}</small>
                <span class="d-block">{{access.customer?.attributes?.["NAME"]}}</span>
                @if (access.partyContact) {
                  <small class="d-block">
                    @if (access.partyContact.street) {
                      <span class="d-block">{{ access.partyContact.street }}</span>
                    }
                    @if (access.partyContact.zip && access.partyContact.city) {
                      <span class="d-block"> {{ access.partyContact.zip }} {{ access.partyContact.city }} </span>
                    }
                    @if (access.partyContact.country) {
                      <span class="d-block">{{ access.partyContact.country }}</span>
                    }
                  </small>
                }
              </td>
              <td class="align-middle">
                <span class="d-block">
                  {{ access.personFirstname! }}
                  {{ access.personLastname! }}
                </span>
                <a [href]="'mailto:' + access.personEmail" class="d-block">{{ access.personEmail }}</a>
              </td>
              <td class="align-middle text-nowrap">{{ "Template.DataApprovalsComponent.text_dateTime" | translate : { dateTime: access.requestDate | date : "dd.MM.yyyy, HH:mm" } }}</td>
              <td class="align-middle text-nowrap">{{ "Template.DataApprovalsComponent.text_dateTime" | translate : { dateTime: access.responseDate | date : "dd.MM.yyyy, HH:mm" } }}</td>
              <td class="text-right align-middle">
                <button (click)="setAccess(access, 'DENIED')" class="btn btn-outline-danger btn-sm d-block w-100" [disabled]="access.loading">
                  @if (!access.loading) {
                    <fa-icon icon="times"></fa-icon>
                  }
                  @if (access.loading) {
                    <fa-icon icon="spinner" animation="spin"></fa-icon>
                  }
                  {{ "Template.DataApprovalsComponent.btn_end" | translate }}
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
}

@if (!loading && (accesses | statusFilter : 'DENIED')?.length) {
  <div class="mb-4">
    <h5 class="mb-0">{{ "Template.DataApprovalsComponent.subHeader_deniedRequests" | translate }}</h5>
    @if (!loading && accesses?.length) {
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_company" | translate }}</th>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_person" | translate }}</th>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_requested" | translate }}</th>
            <th scope="col">{{ "Template.DataApprovalsComponent.label_approved" | translate }}</th>
            <th scope="col">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (access of accesses | statusFilter : 'DENIED'; track access) {
            <tr>
              <td scope="row" class="align-middle">
                <strong class="d-block">{{ "Template.DataApprovalsComponent.text_customerNo" | translate : { customerNo: access.customer! | identification : "CUSTOMER_NO" } }}</strong>
                <small class="d-block">{{ "Template.DataApprovalsComponent.text_gln" | translate : { gln: access.customer! | identification : "GLN" } }}</small>
                <span class="d-block">{{access.customer?.attributes?.["NAME"]}}</span>
                @if (access.partyContact) {
                  <small class="d-block">
                    @if (access.partyContact.street) {
                      <span class="d-block">{{ access.partyContact.street }}</span>
                    }
                    @if (access.partyContact.zip && access.partyContact.city) {
                      <span class="d-block"> {{ access.partyContact.zip }} {{ access.partyContact.city }} </span>
                    }
                    @if (access.partyContact.country) {
                      <span class="d-block">{{ access.partyContact.country }}</span>
                    }
                  </small>
                }
              </td>
              <td class="align-middle">
                <span class="d-block">
                  {{ access.personFirstname! }}
                  {{ access.personLastname! }}
                </span>
                <a [href]="'mailto:' + access.personEmail" class="d-block">{{ access.personEmail }}</a>
              </td>
              <td class="align-middle text-nowrap">{{ "Template.DataApprovalsComponent.text_dateTime" | translate : { dateTime: access.requestDate | date : "dd.MM.yyyy, HH:mm" } }}</td>
              <td class="align-middle text-nowrap">{{ "Template.DataApprovalsComponent.text_dateTime" | translate : { dateTime: access.responseDate | date : "dd.MM.yyyy, HH:mm" } }}</td>
              <td class="text-right align-middle">
                <button (click)="setAccess(access, 'APPROVED')" class="btn btn-outline-success btn-sm d-block w-100" [disabled]="access.loading">
                  @if (!access.loading) {
                    <fa-icon icon="check"></fa-icon>
                  }
                  @if (access.loading) {
                    <fa-icon icon="spinner" animation="spin"></fa-icon>
                  }
                  {{ "Template.DataApprovalsComponent.btn_approve" | translate }}
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
}
